// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CategoryParentReferenceModel from '../../model/category-parent-reference-model';
import CategoryParentReferenceDTO from '../dto/category-parent-reference-dto';
import dtoSchema from '../schemas/category-parent-reference-schema';

export default abstract class CategoryParentReferenceModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CategoryParentReferenceDTO>) {
    super();
    if (data) {
      this.id = data.id ?? undefined;
      this.title = data.title ?? undefined;
    }
  }
  /**
  */
  id?: string;
  /**
  */
  title?: string;

  static toModel(dto: DeepPartial<CategoryParentReferenceDTO>): CategoryParentReferenceModel;
  static toModel(dto: DeepPartial<CategoryParentReferenceDTO> | undefined | null): CategoryParentReferenceModel | undefined;
  static toModel(dto: DeepPartial<CategoryParentReferenceDTO> | undefined | null): CategoryParentReferenceModel | undefined {
    return dto ? new CategoryParentReferenceModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CategoryParentReferenceModel> | CategoryParentReferenceModel): CategoryParentReferenceDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      title: unwrapped.title,
    } as CategoryParentReferenceDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CategoryParentReferenceModel, can not map to CategoryParentReferenceDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
